export default {
  fontFamily: ['Roboto', 'sans-serif'].join(','),
  fontWeightRegular: '500',
  h1: {
    fontWeight: 700,
    fontSize: 40,
    letterSpacing: '-0.24px',
  },
  h2: {
    fontWeight: 700,
    fontSize: 32,
    letterSpacing: '-0.24px',
  },
  h3: {
    fontWeight: 700,
    fontSize: 26,
    letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 700,
    fontSize: 22,
    letterSpacing: '-0.06px',
  },
  h5: {
    fontWeight: 700,
    fontSize: 17,
    letterSpacing: '-0.05px',
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
  },
  overline: {
    fontWeight: 500,
  },
};
